import { updateObject } from 'store/utility';
import {
    ADD_CARRIER_CONFIG,
    ADD_SHIPPER_CONFIG,
    ADD_ALL_SHIPPER_CONFIG,
    CARRIER_CONFIG_EXIST,
    GET_SHIPPER_CONFIG,
    RESET_CARRIER_CONFIG_EXIST
} from '../actions/types';
const initialState = {
    carrierConfigObj: {
        carrierName: '',
        carrierScac: '',
        carrierMc: '',
        carrierDot: '',
        macroPointId: '',
        accountId: '',
        authentication_credentials: {},
        enabled: true,
        sendAssets: false,
        dataSourceId: ''
    },
    shipperConfig: {
        dataSourceId: '',
        accountId: '',
        shipperCode: '',
        macropointID: ''
    },
    shipperConfigs: [],
    carrierConfigExist: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ADD_CARRIER_CONFIG:
            return updateObject(state, {
                carrierConfigObj: action.payload ?? initialState.carrierConfigObj
            });
        case ADD_SHIPPER_CONFIG:
            return updateObject(state, { shipperConfig: action.payload });
        case ADD_ALL_SHIPPER_CONFIG:
            return updateObject(state, { shipperConfigs: action?.payload });
        case GET_SHIPPER_CONFIG:
            return updateObject(state, {
                shipperConfigObj: action?.payload
            });
        case CARRIER_CONFIG_EXIST:
            return { ...state, carrierConfigExist: true };
        case RESET_CARRIER_CONFIG_EXIST:
            return { ...state, carrierConfigExist: false };
        default:
            return state;
    }
};
